import { MultiToggle } from 'components'
import { useGetQuery, usePostQuery } from 'hooks'
import { useParams } from 'react-router-dom'

export const HostKaraokeEdit = () => {
  const { slug } = useParams()

  const { data, error, isFetching, reFetch } = useGetQuery({
    url: `/host/queue/${slug}`
  })

  const { post } = usePostQuery({})

  const changeState = ({ target: { name, value } }) => {
    post({ id: data?.queue?.id, state: value[1] }, `/queues/${data.queue.id}`)
    reFetch(true)
  }

  return (
    <div>
      Karaoke edit {slug} {data?.queue?.name}
      <MultiToggle
        data={[
          ['Pending', 'pending', 'warning'],
          ['Active', 'active', 'success'],
          ['Completed', 'completed'],
          ['Delete', 'deleted', 'chrome']
        ]}
        step={data?.queue?.state}
        name="state"
        onChange={changeState}
      />
    </div>
  )
}
